import { useSwitchState } from 'hooks/useSwitchState'
import { useEffect } from 'react'

const useOpenContentWarning = (hasUploads: boolean) => {
  const [
    isOpenContentWarning,
    ,
    closeOpenContentWarning,
    toggleOpenContentWarning,
  ] = useSwitchState()

  useEffect(() => {
    if (!hasUploads) closeOpenContentWarning()
  }, [hasUploads])

  return {
    isOpenContentWarning,
    toggleOpenContentWarning,
  }
}

export default useOpenContentWarning
